export const routes = {
  home: '/',
  oldSale: '/home',
  sale: '/sale',
  marketplace: '/marketplace',
  neoBroker: '/neobroker',
  staking: '/staking'
}
